// BUSINESS DESK — écran verrouillage : création du PIN au 1er lancement puis déverrouillage.
import { useEffect, useState } from "react";
import { deskApi, setToken } from "./deskApi";

const PAD = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "⌫"];

export default function DeskLock({ onUnlocked }) {
  const [configured, setConfigured] = useState(null);
  const [phase, setPhase] = useState("enter");
  const [pin, setPin] = useState("");
  const [firstPin, setFirstPin] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    deskApi("/auth/status").then((d) => setConfigured(d.configured)).catch(() => setConfigured(false));
  }, []);

  const submit = async (value) => {
    setBusy(true);
    setError("");
    try {
      if (!configured) {
        if (phase === "enter") {
          setFirstPin(value);
          setPhase("confirm");
          setPin("");
          setBusy(false);
          return;
        }
        if (value !== firstPin) {
          setError("Les codes ne correspondent pas — recommencez.");
          setPhase("enter");
          setFirstPin("");
          setPin("");
          setBusy(false);
          return;
        }
        const d = await deskApi("/auth/setup", { method: "POST", body: { pin: value } });
        setToken(d.token);
        onUnlocked();
      } else {
        const d = await deskApi("/auth/unlock", { method: "POST", body: { pin: value } });
        setToken(d.token);
        onUnlocked();
      }
    } catch (e) {
      setError(e.message);
      setPin("");
    } finally {
      setBusy(false);
    }
  };

  const press = (k) => {
    if (busy) return;
    setError("");
    if (k === "⌫") return setPin((p) => p.slice(0, -1));
    if (!k) return;
    const next = (pin + k).slice(0, 6);
    setPin(next);
    if (next.length === 6) submit(next);
  };

  const canValidate = pin.length >= 4;
  const title = configured === false
    ? (phase === "enter" ? "Créez votre code PIN" : "Confirmez votre code PIN")
    : "Business Desk";
  const sub = configured === false
    ? "4 à 6 chiffres — il protégera vos devis, factures et reçus"
    : "Entrez votre code PIN pour déverrouiller";

  if (configured === null) return <div className="desk-lock" data-testid="desk-lock-loading">Chargement…</div>;

  return (
    <div className="desk-lock" data-testid="desk-lock-screen">
      <div className="desk-lock-logo">💼</div>
      <h1>{title}</h1>
      <p>{sub}</p>
      <div className="desk-pin-dots" data-testid="desk-pin-dots">
        {[0, 1, 2, 3, 4, 5].slice(0, Math.max(4, pin.length)).map((i) => (
          <span key={i} className={`desk-pin-dot ${i < pin.length ? "filled" : ""}`} />
        ))}
      </div>
      <div className="desk-lock-error" data-testid="desk-lock-error">{error}</div>
      <div className="desk-numpad" data-testid="desk-numpad">
        {PAD.map((k, i) => (
          <button key={i} data-testid={k ? `desk-pad-${k === "⌫" ? "del" : k}` : undefined} style={!k ? { visibility: "hidden" } : undefined} onClick={() => press(k)}>
            {k}
          </button>
        ))}
      </div>
      <button
        className="desk-btn desk-btn-gold"
        style={{ maxWidth: 260 }}
        data-testid="desk-pin-validate-btn"
        disabled={!canValidate || busy}
        onClick={() => submit(pin)}
      >
        {busy ? "…" : configured === false ? (phase === "enter" ? "Continuer" : "Créer le code") : "Déverrouiller"}
      </button>
    </div>
  );
}
